export default "__VITE_ASSET__B4zRRmKA__"